<template>
  <div>
    <v-divider/>
    <div v-if="formState!=='signup' && allowSignUp"
         class="fin-color-primary-dark--text mb-0 text-center" :class="$vuetify.breakpoint.xsOnly ? 'mt-2' :'py-5'">
      Du hast noch kein Konto?
      <v-btn :id="`signUpLink${isApp ? '_App':''}`"
             @click="startRegistration"
             color="fin-color-primary-dark"
             text>
        <span class="fin-color-accent-green--text">Jetzt registrieren</span>
      </v-btn>
    </div>
  </div>
</template>

<script>

import AmplitudePush from "@/mixins/AmplitudePush"
import finBrowser from "@/js/finBrowser"

export default {
  name: 'FinNoAccountYet',
  mixins: [AmplitudePush],
  props: {
    formState: {
      type: String,
      default: 'signin'
    },
    allowSignUp: {
      type: Boolean
    }
  },
  data() {
    return {
      isApp: finBrowser.IS_IOS_OR_ANDROID_APP
    }
  },
  methods: {
    startRegistration() {
      this.pushToAmplitude({
        "event": "fincraft_registration",
        "step": "registration_start",
        "placement": "login_page",
        "vue_breakpoint": this.$vuetify.breakpoint.name
      })
      this.$router.push({name: 'onbregstart'})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
